<template>
    <b-container fluid>
        <b-row>
            <b-col>
                <dashboard-filters
                    key="customer"
                    :roles="rolesOptions"
                    :officers="OfficerOptions"
                    :order-types="orderTypesOptions"
                    @select-officer="selectedOfficer = $event"
                    @select-role="selectedRole = $event"
                    @select-order-type="selectedType = $event"
                    @select-range="selectedRange = $event"
                    :filters="['officer', 'role', 'orderType', 'dataRange']"
                />
            </b-col>
        </b-row>
        <b-row no-gutters>
            <b-col md="6"  class="mt-2">
                <h6>Team</h6>
                <column-chart
                    :min="0"
                    :max="5"
                    xtitle="Officers"
                    ytitle="Rating"
                    :round="1"
                    :data="teamGraph"
                ></column-chart>
            </b-col>
            <b-col md="6"  class="mt-2">
                <h6>Monthly</h6>
                <line-chart
                    :min="0"
                    :max="5"
                    xtitle="Months"
                    ytitle="Rating"
                    :round="1"
                    :data="monthlyRating"
                ></line-chart>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import graphMixins from '@/mixins/graphMixins'

import DashboardFilters from '@/views/Dashboard/DashboardFilters'
export default {
    name: 'CustomerCharts',
    components: {
        DashboardFilters,
    },
    mixins: [graphMixins],

    data() {
        return {}
    },
    computed: {
        teamGraph() {
            const $this = this
            return (this.officers || []).map(x => [
                x.name,
                $this.avgOfficerRating(x.id),
            ])
        },
        monthlyRating() {
            const $this = this
            return this.lastSixMonths.map(x => [
                this.monthNames[x.month],
                $this.monthRating(x.month, x.year),
            ])
        },
    },
    watch: {
        teamGraph: {
            handler: function (x) {
                console.log('teamGraph', x)
            },
            deep: true,
        },
    },
    methods: {
        monthRating(month, year) {
            const monthOrders = this.filteredOrders.filter(
                x => x.created_year === year && x.created_month === month
            )
            const totalRating = monthOrders.reduce((sum, order) => {
                sum += order.feedback
                return sum
            }, 0)
            return totalRating / monthOrders.length
        },
        avgOfficerRating(id) {
            const officerOrders = this.filteredOrders.filter(
                x => x.officer_id === id
            )
            const totalRating = officerOrders.reduce((sum, order) => {
                sum += order.feedback
                return sum
            }, 0)
            return totalRating / officerOrders.length
        },
    },
}
</script>